module.exports = __webpack_public_path__ + "static/the-quantum-universe-dd4fa7a118012e9ea18543c5b910b1da.jpg";